import { WpEtEnrollment } from './wp-et-enrollment.model';
import { WpTraining } from './wp-training.model';


export class WpEmpAssessment {
    constructor(
        public id?: number,
        public empAssessmentType?: string,
        public assessmentDate?: any,
        public createdBy?: string,
        public createdDate?: any,
        public lastModifiedDate?: any,
        public presentEmpName?: string,
        public presentSalary?: number,
        public freqCurrent?: any,
        public empNamePast?: string,
        public typeWorkPast?: string,
        public endDtPast?: any,
        public rsnLeftPast?: string,
        public salaryPast?: number,
        public freqPast?: any,
        public jobLookingSw?: string,
        public orgHelpSw?: string,
        public orgHelpName?: string,
        public addrLine1?: string,
        public addrLine2?: string,
        public city?: string,
        public state?: string,
        public addrZip5?: string,
        public phoneNum?: string,
        public highestGradeComp?: string,
        public driverLicenseSw?: string,
        public transportationSw?: string,
        public compSkillsSw?: string,
        public learnDifficultySw?: string,
        public readDifficultySw?: string,
        public fullTimeCareSw?: string,
        public primaryCareSw?: string,
        public drugProbSw?: string,
        public drugProbExp?: string,
        public criminalSw?: string,
        public criminalExp?: string,
        public domesticIssueSw?: string,
        public domesticIssueExp?: string,
        public statusCd?: string,
        public trainingHistorySw?: string,
        public wpEtEnrollment?: WpEtEnrollment,
        public wpEmpTrainings?: WpTraining[],
        public lastUpdatedDt?: any,
    ) {
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/model/wp-emp-assessment.model.ts